import React from "react";
import Icon from "components/AppIcon";

const TESTIMONIALS = [
  {
    name: "Rahul Sharma",
    role: "Owner, IronCore Fitness",
    location: "Mumbai",
    quote: "myfitnesstracking cut our admin time by 60%. Member renewals are now automated and our staff actually enjoys using the software.",
    rating: 5,
    initials: "RS",
    color: "bg-teal-500",
  },
  {
    name: "Priya Nair",
    role: "Director, FitZone Chain",
    location: "Bangalore",
    quote: "Managing 8 branches used to be a nightmare. Now I get a single dashboard view of everything — revenue, attendance, staff performance.",
    rating: 5,
    initials: "PN",
    color: "bg-violet-500",
  },
  {
    name: "Arjun Mehta",
    role: "Founder, PeakPerformance Gym",
    location: "Delhi",
    quote: "The billing automation alone saved us ₹40,000/month in missed renewals. The ROI was clear within the first week.",
    rating: 5,
    initials: "AM",
    color: "bg-amber-500",
  },
];

export default function TestimonialsSection() {
  return (
    <section id="testimonials" className="py-24 px-4">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <span className="text-teal-400 text-sm font-semibold font-caption uppercase tracking-wider">Testimonials</span>
          <h2 className="text-4xl sm:text-5xl font-bold font-heading mt-3 mb-4">
            Gym owners love myfitnesstracking
          </h2>
          <p className="text-slate-400 font-body">Real results from real gym businesses across India.</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {TESTIMONIALS?.map((t) => (
            <div
              key={t?.name}
              className="bg-slate-900/60 border border-white/5 hover:border-white/10 rounded-2xl p-6 transition-all duration-300 hover:-translate-y-1 hover:shadow-xl hover:shadow-black/20"
            >
              {/* Stars */}
              <div className="flex gap-1 mb-4">
                {Array.from({ length: t?.rating })?.map((_, i) => (
                  <Icon key={i} name="Star" size={14} color="#fbbf24" />
                ))}
              </div>

              <p className="text-slate-300 text-sm font-body leading-relaxed mb-6">
                "{t?.quote}"
              </p>

              <div className="flex items-center gap-3">
                <div className={`w-10 h-10 rounded-full ${t?.color} flex items-center justify-center text-white text-sm font-bold font-caption flex-shrink-0`}>
                  {t?.initials}
                </div>
                <div>
                  <div className="text-sm font-semibold text-white font-caption">{t?.name}</div>
                  <div className="text-xs text-slate-500 font-body">{t?.role} · {t?.location}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
